import { ActionIcon, Divider, Group, ScrollArea, SegmentedControl, Stack, Text, Title } from "@mantine/core";
import { FaXmark } from "react-icons/fa6";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  type IMcBimItemsFilterMode,
  setActiveLeftSideBarTabInRedux,
  setMcBimItemsFilterModeInRedux,
} from "../designSlice";
import { IfcClassesMenuContent } from "../GlobalDesignBar/ComponentsMenu/IfcClassesMenuContent";
import { DisciplinesMenuContent } from "../GlobalDesignBar/ComponentsMenu/DisciplinesMenuContent";

export const ComponentsPanel = () => {
  const dispatch = useAppDispatch();
  const filterMode = useAppSelector(state => state.design.mcbimItemsFilterMode);

  return (
    <Stack h="100%" gap="md" style={{ minHeight: 0 }} role="region" aria-labelledby="components-panel-title">
      <Group justify="space-between" wrap="nowrap">
        <Title order={4} id="components-panel-title">Komponenter</Title>
        <ActionIcon variant="subtle" color="gray" aria-label="Lukk komponenter"
          onClick={() => dispatch(setActiveLeftSideBarTabInRedux(undefined))}>
          <FaXmark />
        </ActionIcon>
      </Group>
      <Stack gap={6}>
        <Text size="xs" fw={600} c="dimmed" id="components-filter-label">Filtertype</Text>
        <SegmentedControl fullWidth size="sm" aria-labelledby="components-filter-label"
          value={filterMode}
          onChange={value => dispatch(setMcBimItemsFilterModeInRedux(value as IMcBimItemsFilterMode))}
          data={[{ value: "INSTANCE_CLASS", label: "IFC-klasser" }, { value: "DISCIPLINE", label: "Disiplin" }]} />
      </Stack>
      <Divider />
      {filterMode === "DISCIPLINE" ? (
        <ScrollArea style={{ flex: 1, minHeight: 0 }} type="auto" offsetScrollbars>
          <DisciplinesMenuContent />
        </ScrollArea>
      ) : (
        <div style={{ flex: 1, minHeight: 0 }}><IfcClassesMenuContent /></div>
      )}
    </Stack>
  );
};
